<template>
    <div class="form-switch">
        <template v-for="(option, index) in options" :key="option.id">
            <input class="form-switch__input" type="radio" :name="name" :id="`${name}-${option.id}`" v-model="value"
                   :value="option.value || option.id">
            <label class="form-switch__label" :for="`${name}-${option.id}`">{{ option.name }}</label>

            <span v-if="!index" class="form-switch__toggle" @click="setValue(value)"></span>
        </template>
    </div>
</template>

<script>
export default {
    name: "InputSwitch",
    emits: ["update:modelValue"],
    props: {
        modelValue: {
            type: [String, Number, Boolean],
            default: "",
        },
        name: {
            type: String,
            default: 'input-switch'
        },
        options: {
            type: Array,
            required: true,
            validator(value) {
                return value.length === 2
            },
            default: () => [],
        },
    },
    mounted() {
        if (!this.value) this.value = this.options[0].value || this.options[0].id
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit("update:modelValue", value)
            },
        },
    },
    methods: {
        setValue(val) {
            if (this.value === val) {
                this.value = this.options[1].value
            } else {
                this.value = val
            }
        }
    }
}
</script>

<style scoped>

</style>